import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = (n) => (_pushScopeId("data-v-0023fd5d"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "main-container" };
const _hoisted_2 = { class: "left-container" };
const _hoisted_3 = { class: "center-container" };
const _hoisted_4 = {
    id: "MainTitle",
    class: "text-lg sm:text-xl md:text-2xl"
};
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/ _createElementVNode("br", null, null, -1));
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = { class: "flex items-center space-x-3 bg-header p-4 rounded-lg shadow-md" };
const _hoisted_8 = {
    for: "checkbox",
    class: "flex items-center space-x-2 text-gray-100"
};
const _hoisted_9 = { class: "right-container" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_hit_button = _resolveComponent("hit-button");
    const _component_hit_panel = _resolveComponent("hit-panel");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_hit_button, {
                    "suffix-icon": "back",
                    "icon-size": "lg",
                    color: "accent",
                    onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('previousClick')))
                })
            ]),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.t('admin-ui.terms_and_conditions_of_use')), 1),
                _hoisted_5,
                _createVNode(_component_hit_panel, {
                    size: "maximized",
                    resizable: false,
                    "handle-content-loading": true
                }, {
                    body: _withCtx(() => [
                        _createElementVNode("div", {
                            class: "p-4 rounded-lg h-96 m-2 bg-gray-100 overflow-y-scroll",
                            innerHTML: _ctx.termsAndConditions
                        }, null, 8, _hoisted_6)
                    ]),
                    _: 1
                }),
                _createElementVNode("div", _hoisted_7, [
                    _withDirectives(_createElementVNode("input", {
                        id: "checkbox",
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.checked) = $event)),
                        type: "checkbox",
                        class: "h-5 w-5 hit-checkbox border-gray-300 rounded"
                    }, null, 512), [
                        [_vModelCheckbox, _ctx.checked]
                    ]),
                    _createElementVNode("label", _hoisted_8, [
                        _createElementVNode("span", null, _toDisplayString(_ctx.t('admin-ui.text_accept_agreement')), 1)
                    ])
                ])
            ]),
            _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_hit_button, {
                    color: "accent",
                    disabled: !_ctx.getRightState,
                    "suffix-icon": "forward",
                    "icon-size": "lg",
                    onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.$emit('nextClick', _ctx.listModules, _ctx.count)))
                }, null, 8, ["disabled"])
            ])
        ])
    ]));
}
